/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S4_Item1_LabelInputs */

const tr_cerez_s4_item1_label = /** @type {(inputs: Cerez_S4_Item1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturum çerezleri:`)
};

const en_cerez_s4_item1_label = /** @type {(inputs: Cerez_S4_Item1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session cookies:`)
};

const de_cerez_s4_item1_label = /** @type {(inputs: Cerez_S4_Item1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungs-Cookies:`)
};

const ru_cerez_s4_item1_label = /** @type {(inputs: Cerez_S4_Item1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сессионные файлы cookie:`)
};

/**
* | output |
* | --- |
* | "Session cookies:" |
*
* @param {Cerez_S4_Item1_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s4_item1_label = /** @type {((inputs?: Cerez_S4_Item1_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S4_Item1_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s4_item1_label(inputs)
	if (locale === "de") return de_cerez_s4_item1_label(inputs)
	if (locale === "ru") return ru_cerez_s4_item1_label(inputs)
	return tr_cerez_s4_item1_label(inputs)
});